// react
import { useState } from "react";
// libs
import { motion, Variants } from "framer-motion";
import styled from "styled-components";
// components
import { IconKey } from "../models/client";
import Icon from "./Icon";
// other
import { theme } from "../styles/theme";

type RatingConfig = { icon: IconKey; value: string };
const config: RatingConfig[] = [
  {
    icon: "sentimentVerySatisfied",
    value: "verySatisfied",
  },
  {
    icon: "sentimentSatisfied",
    value: "satisfied",
  },
  {
    icon: "sentimentNeutral",
    value: "neutral",
  },
  {
    icon: "sentimentDissatisfied",
    value: "dissatisfied",
  },
  {
    icon: "sentimentVeryDissatisfied",
    value: "veryDissatisfied",
  },
];

const buttonVariants: Variants = {
  on: { color: theme.colors.salmon, opacity: 1 },
  off: { color: theme.colors.white, opacity: 0.3 },
};

const StyledMotionButton = styled(motion.button)`
  background-color: transparent;
  color: ${({ theme }) => theme.colors.white};
  border: none;
  cursor: pointer;
  padding: 0;
  svg {
    vertical-align: middle;
  }
`;

function IconRating() {
  const [rating, setRating] = useState<string | null>(null);

  return (
    <div className="star-rating">
      {config.map(({ icon, value }, index) => {
        index += 1;
        return (
          <StyledMotionButton
            type="button"
            key={index}
            animate={rating === value ? "on" : "off"}
            variants={buttonVariants}
            onClick={() => setRating(value)}
            whileHover="on"
          >
            <Icon icon={icon} />
          </StyledMotionButton>
        );
      })}
    </div>
  );
}

export default IconRating;
